import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from '@/config/routes'
import store from '../stores/store'
import { getProfile } from "../services/apiService";
import jwtService from "../services/jwt";

Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  mode: 'history'
})

router.beforeEach(async (to, from, next) => {
  // VALIDATE TOKEN
  if (!(to.path === '/login' || to.path === '/recoverypassword')) {
    // console.log('in validaton before each')
    const tokenValidation = await jwtService.validateToken()
    // console.log("tokenValidation: ", tokenValidation)
    if (tokenValidation instanceof Error) {
      localStorage.clear();
      setTimeout(() => {
        next('/login')
      }, 200);
    }
  }

  if (!store.state.auth.isLoggedIn) {
    if (to.name === 'recoverypassword') {
      next()
    } else {
      if (to.name !== 'login') next({ name: 'login' })
      else next()
    }
  }
  else {
    if (store.state.auth.token || store.state.auth.token !== '') {
      const profile = await getProfile('channel/api/profile')
      let menuCondition = 0;

      await store.dispatch('setUser', profile.data.user)

      menuCondition = store.state.userProfile.userProfile.userCollected ? 1 : 0;

      const urlProtected = ['/administracion-usuarios', '/inscripcionrecaudo', '/mispagos'];
      const urlFacturas = ['/mis-facturas'];

      if (!store.state.auth.completed && to.path !== '/profile') {
        return next('/profile')
      } else {
        if (!store.state.userProfile.userProfile.client && to.path !== '/profile' ||
          store.state.userProfile.userProfile.status !== 'ACTIVE' && to.path !== '/profile') {
          return next('/profile')
        }
        if (!store.state.userProfile.userProfile.isAdmin && urlProtected.some(url => url == to.path)) {
          return next('/home')
        }
        //si no tiene credito corto activo
        let credito = store?.state?.userProfile?.userProfile?.client?.creditoCorto
        if (!credito && urlFacturas.some(url => url == to.path)) {
          return next('/home')
        }
        if (to.name == 'inscripcionrecaudo') {
          return next()
        } else if (to.name == 'inscripcionrecaudo') {
          return next('/mispagos')
        }
        if (to.name == 'mispagos' && menuCondition == 1) {
          return next()
        } else if (to.name == 'mispagos') {
          return next('/inscripcionrecaudo')
        }

        return next()
      }
    } else {
      next()
    }
  }
})

/*router.afterEach(function (transition) {
})*/

// Con code splitting, un usuario con la pestaña abierta durante un deploy puede
// pedir un chunk que ya no existe en el bundle nuevo. Recargar resuelve el caso.
// Guard con sessionStorage (mismo patrón que interceptor.js: flag antes de actuar)
// para no entrar en loop de recargas si el chunk sigue faltando tras recargar
// (build roto de verdad, no solo una pestaña vieja).
router.onError((error) => {
  if (/Loading chunk .* failed|Failed to fetch dynamically imported module/.test(error.message)) {
    if (!sessionStorage.getItem('chunkReloadAttempted')) {
      sessionStorage.setItem('chunkReloadAttempted', 'true')
      window.location.reload()
    }
  }
})

router.afterEach(() => {
  sessionStorage.removeItem('chunkReloadAttempted')
})

export default router
